import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { BaseHttpService } from '@nimbus-library/features/shared/services/base-http/base-http.service';
import { IAuthenticationService } from '@nimbus-library/features/authentication/services/i-authentication.service';
import { IPermissionManagerService } from '@nimbus-library/features/user-settings/services/contracts/i-permission-manager.service';
import { IOrganizationUnitDataService } from '@nimbus-global/features/shared/services/api/organization-unit/organization-unit-data.service';

@Injectable()
export class OrganizationUnitDataService extends IOrganizationUnitDataService {
  protected tenantId$: Observable<string>;

  public constructor(
    baseHttpService: BaseHttpService,
    authService: IAuthenticationService,
    permissionManagerService: IPermissionManagerService,
  ) {
    super(baseHttpService, authService, permissionManagerService);

    this.tenantId$ = this.authService.isAuthenticated$.pipe(
      distinctUntilChanged(),
      map((isAuthenticated) => (isAuthenticated ? this.authService.getUserInfo().tenantId : null)),
    );

    this.initialize();
  }

  public getTenantId(): string {
    const user = this.authService.getUserInfo();
    return user ? user.tenantId : null;
  }
}
